export const statusCodeMap = new Map<number, string>([
  [400, 'Bad request - The server did not understand the request'],
  [
    401,
    'Authentication failed - Either the token has expired, is missing, or invalid'
  ],
  [
    403,
    `Forbidden - You don't have the required permissions to perform this action`
  ],
  [404, 'Route not found - The MP developers screwed up'],
  [
    500,
    "Server error - The server has encountered a situation it doesn't know how to handle"
  ],
  [503, 'Service Unavailable - The server is unable to handle the request']
]);

// https://github.com/developit/unfetch#api
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error

const stripGuids = (path: string) =>
  path
    .replace('', '')
    .split('/')
    .map(p => (p.length === 36 && p.includes('-') ? 'Guid' : p))
    .join('/');

export class HttpNetworkError extends Error {
  date: Date;

  constructor(...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpNetworkError);
    }

    this.name = 'HttpNetworkError';

    // @ts-ignore
    this.date = new Date();
  }
}

export class HttpStatusError extends Error {
  response: Response;
  responseJson: any;

  constructor(response: Response, responseJson: any | undefined) {
    super(
      responseJson?.message ?? HttpStatusError.modifiedStatusText(response)
    );

    try {
      var url = new URL(response.url);

      this.name = 'HttpStatusError: ' + stripGuids(url.pathname);
    } catch (error) {
      this.name = 'HttpStatusError';
    }

    this.response = response;

    this.responseJson = responseJson;
  }

  static modifiedStatusText(response: Response) {
    const message = statusCodeMap.get(response?.status);

    if (message) {
      return `${message} - ${response.url}`;
    }

    return response?.statusText?.length > 0
      ? response.statusText
      : `${response.status}: Unknown reason`;
  }

  getErrorsFromResponse = () => {
    if (!this.responseJson) {
      return [];
    }
    return this.responseJson.errors?.reduce((a, v) => `${a}  ${v}`) ?? [];
  };
}
